export default "__VITE_ASSET__aK0S9gH___"